import { CustomAsyncSelect } from "components/Common/Common";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import React, { memo, useEffect, useRef, useState } from "react";
import { useLazyGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import threDots_img from "Assets/images/three-dots.png"
import { Accordion, Col, Dropdown, Row } from "react-bootstrap";
import SaveStrategyTemplatePop from "components/Modals/SaveStrategyTemplatePop";
import { cloneDeep, isEmpty } from "lodash";
import { promiseToast } from "helpers/common";
import { GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2, MAX_REPORT_ASSESSMENTS, reportDateFormat, TASK_PLAN_SESSION_COLOR_V2, } from "config/constants";
import confirmDialogV2 from "utils/confirmationDialogV2";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useGetGoalStatusListQuery } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { components } from "react-select";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { STRATEGY_OPTIONS } from "config/constants";
import StrategiesTemplatesPop from "components/Modals/StrategyTemplatesPop";
import AddTreatmentPop from "../Modals/AddTreatmentArea";
import SessionTrackingButton from "../TaskPlanSessions/SessionTrackingButton";
import TreatmentGoalTrackChart from "../TreatmentGoalTracking/TreatmentGoalTrackChart";
import EditGoalDetailPop from "../GoalsTracking/components/Modals/EditGoalDetail";
import { useDeleteGoalMutation } from "store/services/clients/assessmentTreatmentPlan/goals/manageGoals";

const QuestionTreatmentChartOnly = ({ fieldName, question, fieldData, previewMode, clientType, assessmentId, therapist, max, maxRecommendations, assessmentAssignedId, refetchData, dataFetching, reportGoals, maxStrategy, chartRefs, handleSubmit, ...props }) => {
    const { setFieldValue, values, touched, errors, setFieldTouched } = useFormikContext();
    const [activeKey, setActiveKey] = useState(0);
   

    return (
        <div>
        

            <div className="goals goals-accordion assessment-report" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "28px" }}>
                <Accordion onClick={(e) => e.stopPropagation()} activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                    {reportGoals?.map((observation, index) => (
                        <>
                            <div style={{ position: 'absolute', left: '-9999px', top: 0, zIndex: 999999999999 }}>
                                <TreatmentGoalTrackChart
                                    trackingData={values?.goals?.[index]?.scores || []}
                                    ref={(el) => {
                                        if (el && chartRefs.current) {
                                            console.log(`Assigning ref for index ${index}:`, el);
                                            chartRefs.current[index] = el;
                                        }
                                    }}
                                    version={2}
                                    isSessionTrail={values.goals?.[index]?.is_trails}
                                />
                            </div>
                        </>

                    ))}
                </Accordion>
            </div>

        </div>
    );
};

export default QuestionTreatmentChartOnly;

